import React, { useEffect, useRef, useState } from "react";
import { Power2, gsap } from "gsap";
import bgImage from "../../Assets/BG-2023.png";
import {
  Duckie,
  Collab,
  Events,
  Faq,
  Footer,
  Happening,
  Concert,
  Hero,
  Menu,
  Navbar,
  Partner,
  Partnership,
  Star,
} from "../../Components/index";
import "./Home.css";

const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const [isActive, setActive] = useState(false);
  const [isMenuActive, setMenuActive] = useState(false);
  const targetHamburgerElement = useRef();
  const t1 = useRef();

  const handleToggle = (event) => {
    event.preventDefault();
    if (targetHamburgerElement.current) {
      setMenuActive(!isMenuActive);
      setActive(!isActive);
    }
  };

  const handleClickCloseMenu = (event) => {
    t1.current.reverse();
    document.body.style.overflow = "inherit";
    setMenuActive(!isMenuActive);
    setActive(!isActive);
  };

  useEffect(() => {
    t1.current = gsap.timeline({ paused: true });
    t1.current.to(".menu", {
      opacity: 1,
      duration: 1,
      top: 0,
      left: 0,
      ease: Power2.easeInOut,
    });
    t1.current.to(
      ".nav",
      {
        opacity: 1,
        marginBottom: 0,
        duration: 1,
        ease: Power2.easeInOut,
        stagger: 0.3,
      },
      ">-0.5"
    );
  }, []);

  useEffect(() => {
    isMenuActive ? t1.current.play() : t1.current.reverse();
    isMenuActive
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "inherit");
    console.log(t1);
  }, [isMenuActive]);

  return (
    <>
     
      <div className="bg-black relative home-parent flex justify-center" style={{ zIndex: 2 }}>
        
        <video
          autoPlay
          muted
          loop
          playsInline
          className="hero-img hidden md:block"
        >
          <source src={require("../../Assets/Hero-2023.mp4")} type="video/mp4" />
        </video>
        <img
          className="hero-mobile-img md:hidden"
          src={require("../../Assets/Hero-mobile-2023.png")}
          alt="hero"
        />
        <div className="container mx-auto px-4 pt-10 pb-10 h-full absolute top-0">
          <Navbar
            ref={targetHamburgerElement}
            handleToggleHamburger={handleToggle}
            isActive={isActive}
            className="relative"
          />
          <Hero className="relative" setShowModal={setShowModal} />
          <Menu handleOnClick={handleClickCloseMenu} />
        </div>
      </div>
      <Duckie showModal={showModal} setShowModal={setShowModal} />
      <Partnership />
      <div
        className="mx-auto  md:pt-48 pb-10 h-full relative bg-linear-choco"
        style={{ backgroundImage:`url(${bgImage})`, backgroundSize: "cover" }}
      >
        <Star setShowModal={setShowModal} />
        <Concert />
        <Happening setShowModal={setShowModal} />
        <Events />
        <Partner />
        <Collab />
        <Faq setShowModal={setShowModal} />
      </div>
      <div className="relative overflow-hidden" style={{ backgroundColor: '#D1597A', zIndex: 2 }}>
        <div className="container mx-auto px-4 pt-10 pb-10 relative">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Home;
